import React, { useEffect, useState } from "react";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { setInquiryPopup } from "@/store/slices/inquirySlice";
import { usePathname } from "next/navigation";

const BottomStrip = ({
  // isAmenityActive,
  isMobilescreen,
  projectTheme,
  projects_full_list_detail,
}) => {
  const dispatch = useDispatch();
  const inquiryPopup = useSelector((state) => state.inquiry.inquiryPopup);
  const isAmenityActive = useSelector((state) => state.inquiry.isAmenityOpen);
  const isProximityActive = useSelector(
    (state) => state.inquiry.isProximityOpen,
  );
  const [showStrip, setShowStrip] = useState(false);
  const [fixedBtnActive, setFixedBtnActive] = useState(false);
  const pathName = usePathname();
  const excludedPaths = [
    "/",
    "/projects",
    "/career",
    "/contact-us",
    "/about-us",
    "/channelpartner",
    "/media",
  ];
  const isThankYouPage = pathName?.includes("/thankyou");
  const shouldEnableScrollEffect =
    !excludedPaths.includes(pathName) && !isThankYouPage;

  const hideStrip = isProximityActive || isAmenityActive || inquiryPopup;

  useEffect(() => {
    if (!shouldEnableScrollEffect) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const remainingDistance = documentHeight - (scrollTop + windowHeight);

      if (scrollTop > 600 && remainingDistance > 600) {
        setShowStrip(true);
        setFixedBtnActive(true);
      } else if (scrollTop < 200) {
        setShowStrip(false);
        setFixedBtnActive(false);
      } else if (remainingDistance >= 600) {
        setTimeout(() => {
          setShowStrip(true);
          setFixedBtnActive(true);
        }, 100);
      }

      if (remainingDistance < 600 || scrollTop < 600) {
        setTimeout(() => {
          setShowStrip(false);
          setFixedBtnActive(false);
        }, 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldEnableScrollEffect]);

  const onInquireClick = () => {
    dispatch(setInquiryPopup(true));
  };

  // useEffect(() => {
  //   console.log(isAminities);
  // }, [isAminities]);

  // if (!projects_full_list_detail) return null;

  return (
    <>
      {projects_full_list_detail &&
        pathName != "/" &&
        pathName != "/projects" &&
        pathName != "/career" &&
        pathName != "/contact-us" &&
        pathName != "/about-us" &&
        pathName != "/channelpartner" &&
        pathName != "/media" &&
        pathName != "/blogs" &&
        !pathName.includes("/thankyou") &&
        !pathName.startsWith("/blogs/") && (
          <div
            className={`bottomStrip ${
              hideStrip || !showStrip ? "hide-strip" : "showStrip"
            }`}
            onClick={onInquireClick}
            id="bottomStrip"
            style={projectTheme}
          >
           <div className="icon-inquire0now">
            <img src="/images/new-icons/inquire.svg" alt="" />
           </div>
           <p className="white-color">
            Interested in {projects_full_list_detail.project_title}
           </p>
          </div>
        )}
      {/* Floating WhatsApp Button */}
    
    </>
  );
};

export default BottomStrip;
